import React from "react";
/*import '../../styles/requestConfirmed.css';*/
import "../../styles/uploadimage.css";
import "../../styles/accept-buy-request.css";
import "../../styles/place-buy-requests.css";
import {Redirect} from "react-router-dom";
import {CountryDropdown} from "react-country-region-selector";
import {inject, observer} from "mobx-react";
import {
    validateIfInputHasCharacters,
    validateIfInputHasCharactersAllowSpaces,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateIfInputIsEmail,
    validateInputLength
} from "../../../src/helpers/validationChecks";
import ReactGA from "react-ga";
// import 'react-phone-number-input/style.css'
// import PhoneInput from 'react-phone-number-input'

// var ReactTelephoneInput = require('react-telephone-input');
@inject('userStore', 'generalStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'likeAndUnlikeStore', 'requestsStore')
@observer
export default class PlaceBuyRequest extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            country: "",
            confirmed: false,
            artworkInfo: {},
            formInputs: {
                email: "",
                contact_no: "",
                message: "",
                currency_code: "",
                // country_code: "",
                country: "",
            },
        }
    }

    selectCountry(item) {
        this.setState({ formInputs: { ...this.state.formInputs, country: item } }
            , () => { 
                // console.log(this.state.formInputs.country) 
            })
    }

    handleConfirmBuyRequest() {
        this.setState({
            confirmed: true
        })

    }

    handleCurrencySelection(currencyAbbrevation) {
        // console.log(`Selected ${currencyAbbrevation.target.value}`);
        this.setState({
            formInputs: { ...this.state.formInputs, currency_code: currencyAbbrevation.target.value }
        }, function () {
            // console.log(this.state.formInputs.currency_code)
        })
    }
    handleInputTextChange(e) {
        this.setState({
            formInputs: {
                ...this.state.formInputs,
                [e.target.name]: e.target.value
            }

        }, function () {
            // console.log(this.state.formInputs)
        })
    }

    sendBuyRequest() {
        var scope = this
        var base = Object.keys(scope.state.formInputs).map(function (key) {
            return [key, scope.state.formInputs[key]];
        });


        if (!this.state.formInputs.email) {
            this.props.navigatorStore.openErrorModal(`Entering email is mandatory`);
            return;
        }
        if (!!this.state.formInputs.email && !validateIfInputIsEmail(this.state.formInputs.email)) {
            this.props.navigatorStore.openErrorModal(`Please enter a valid email`);
            return;
        }
        if (!this.state.formInputs.currency_code) {
            this.props.navigatorStore.openErrorModal(`Entering currency is mandatory`);
            return;
        }
        if (!!this.state.formInputs.contact_no) {
            if (!this.state.formInputs.country_code) {
                this.props.navigatorStore.openErrorModal(`Please enter the country code`);
                return;
            }
            if (this.state.formInputs.country_code.length > 3) {
                this.props.navigatorStore.openErrorModal(`Please enter a valid country code`);
                return;
            }
            if (this.state.formInputs.contact_no.length > 10) {
                this.props.navigatorStore.openErrorModal(`Please enter valid phone number`);
                return;
            }
        }
        if (!this.state.formInputs.city) {
            this.props.navigatorStore.openErrorModal(`Entering city  is mandatory`);
            return;
        }
        if (!!this.state.formInputs.city && !validateIfInputHasCharactersAllowSpaces(this.state.formInputs.city)) {
            this.props.navigatorStore.openErrorModal(`City cannot contain special characters`);
            return;
        }
        if (!this.state.formInputs.country) {
            this.props.navigatorStore.openErrorModal(`Entering country  is mandatory`);
            return;
        }
        if (!this.state.formInputs.currency_code) {
            this.props.navigatorStore.openErrorModal(`Entering currency is mandatory`);
            return;
        }

        ReactGA.pageview('/Buy request action');

        this.props.requestsStore.artworkBuyRequest(this.props.match.params.artworkid, this.state.formInputs)
            .then((res) => {
                this.setState({
                    br_sent: true
                })

            })

    }

    componentDidMount() {

        ReactGA.pageview('/Buy request screen');

        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }

        this.props.userStore.pulluser().then((result) => {
            // console.log("{this is pulled user}", result)
            result.data[0]

            // if (!result.data[0].interests) {
            //     // console.log("interests null")
            //     this.setState({
            //         onboardingOneIncomplete: true
            //     })
            // }
            // if (!result.data[0].preferences) {
            //     // console.log("preferences null")
            //     this.setState({
            //         onboardingTwoIncomplete: true
            //     })
            // }
            if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                    // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain characters");
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                var formData = new FormData();
                formData.append("display_name", this.state.formInputs.display_name)
                // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                this.props.userStore.validateDisplayName(formData)
                    .then((response) => {
                        // console.log(response)
                        if (response.error == "True") {
                            this.setState({
                                onboardingThreeIncomplete: true,
                                // formInputs: { ...this.state.formInputs, display_name: "" }
                            })
                            // this.props.navigatorStore.openErrorModal(response.data)
                            return;
                        }
                        else {
                            this.setState({
                                onboardingThreeIncomplete: true
                            })
                        }
                    })
                    .catch((err => {
                        this.setState({
                            onboardingThreeIncomplete: true,



                        })
                    }));
            }

            if (result.data[0].display_name) {
                if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                    // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain characters");
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
                if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                    // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                }
            }

            if (!result.data[0].full_name ||
                !result.data[0].country ||
                //  !response.data.user_profile[0].full_name || 
                //  !response.data.user_profile[0].user.email || 
                //  !response.data.user_profile[0].display_name || 
                !result.data[0].display_name ||
                result.data[0].display_name.length >= 30 ||
                !result.data[0].primary_email ||
                !result.data[0].preferred_currency

            ) {
                // console.log("profile null")
                this.setState({
                    onboardingThreeIncomplete: true
                })
                // this.state.makeOnboardingThreeIncomplete()
            }

            this.setState({
                formInputs: {
                    ...this.state.formInputs,
                    email: result.data[0].primary_email,
                    currency_code: localStorage.getItem("preferred_currency"),
                    city: result.data[0].city,
                    country: result.data[0].country,
                }
            })
        })
        this.props.artworksStore.getArtworkDetailsPublicAuth(this.props.match.params.artworkid, null, true)
            .then((res) => {
                // console.log(res);
                this.setState({
                    artworkImage: res.data.data[0].artwork.img1,
                    title: (res.data.data[0].artwork.title) ? (res.data.data[0].artwork.title) : res.data.data[0].artwork.old_title,
                    technique: (res.data.data[0].artwork.base) ? "" : res.data.data[0].artwork.medium,
                    medium: (res.data.data[0].artwork.base) ? res.data.data[0].artwork.medium : "",
                    custom_medium: res.data.data[0].artwork.custom_medium,
                    base: res.data.data[0].artwork.base,
                    custom_base: res.data.data[0].artwork.custom_base,
                    artworkInfo: res.data.data[0].artwork,
                    currency_code: localStorage.getItem("preferred_currency")

                })

            })
    }
    handleInputChange(telNumber, selectedCountry) {
        // console.log('input changed. number: ', telNumber, 'selected country: ', selectedCountry)
    }

    handleInputBlur(telNumber, selectedCountry) {
        // console.log(
        //     'Focus off the ReactTelephoneInput component. Tel number entered is: ',
        //     telNumber,
        //     ' selected country is: ',
        //     selectedCountry
        // )
    }
    handlePhoneChange(phone) {
        // console.log("changed the phone nymber", phone)
    }
    figuredOutMediumAndBase(stringToEdit) {
        if (!!stringToEdit) {
            var removedOthers = stringToEdit.replace(", Others", "");
            removedOthers = removedOthers.replace("Others ,", "");
            removedOthers = removedOthers.replace("Others", "");
            var removedComma = removedOthers.replace(", ,", ",");
            // console.log("got it stringToEdit",
                // { stringToEdit: stringToEdit, removedComma: removedComma, removedOthers: removedOthers })
            if (removedComma.charAt(0) == ",") {
                removedComma = removedComma.substr(1, removedComma.length)
            }
        }
        return removedComma
    }
    render() {

        if (this.state.medium) var figuredOutMedium = this.figuredOutMediumAndBase(this.state.medium);
        if (this.state.base) var figuredOutBase = this.figuredOutMediumAndBase(this.state.base);
        if (this.props.authStore.RegisterSuccess) {
            this.props.authStore.resetRegisterSuccess("onboardingOneIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingTwoIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingThreeIncomplete")
            return (
                <Redirect push to='/onboardingone' />
            )
        }

        // if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingOneIncomplete) {
        //     // console.log("redirecting to onboardingOne");
        //     return (
        //         <Redirect push to="/onboardingone"></Redirect>
        //     )
        // }
        // if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingTwoIncomplete) {
        //     // console.log("redirecting to onboardingTwo");
        //     return (
        //         <Redirect push to="/onboardingtwo"></Redirect>
        //     )
        // }
        // setTimeout(
        //     ()=>{

        if (
            (window.localStorage.hasOwnProperty("userData") && this.state.onboardingThreeIncomplete)
        ) {
            // console.log("identifier redirecting to onboardingThree ", this.props.authStore.updateComplete, this.props.authStore.onboardingThreeIncomplete);

            this.props.authStore.resetUpdateComplete()
            return (
                <Redirect push to="/onboardingthree"></Redirect>
            )
        }

        if (this.state.br_sent) {
            return (
                <Redirect push to="/requestconfirmed" />
            )
        }

        if (this.state.artworkInfo) {
            return (
                <div className="col-sm-12 background-grey">
                    <article className="post-88 page type-page status-publish hentry">
                        <div className="woocommerce">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <div className="heading-welcome_">
                                        PLACE BUY REQUEST
                                    <hr className="line-category-name margin-auto"></hr>
                                    </div>
                                </div>

                                <div className="col-sm-6 UploadPaintingCard no-margin padding-35 placeBuyRequest">
                                    <div className="col-md-12">

                                        <div className="row">
                                            <div className="col-md-4">

                                                <img src={this.state.artworkImage}
                                                    className="image-art" />

                                            </div>

                                            <div className="col-md-8 text-center-sm" style={{ "margin-left": -15 }}>

                                                <h3 className="art-name">{this.state.title}</h3>
                                                {

                                                    (this.state.artworkInfo.wish_to_sell) ?

                                                        localStorage.hasOwnProperty("preferred_currency") ?

                                                            <p className="art-details"> Price :
                                              {` `} {localStorage.getItem("preferred_currency").toUpperCase()}{` `}{Math.round(this.state.artworkInfo[`${localStorage.getItem("preferred_currency").toLowerCase()}_price`] * 10) / 10}*
                                                </p>
                                                            :
                                                            <p className="art-details"> Price :
                                             {(this.state.artworkInfo.seller_price) ?
                                                                    `  ${this.state.artworkInfo.currency_code}` + ` `
                                                                    + Math.round(this.state.artworkInfo.product_base_price * 10) / 10 : Math.round(this.state.artworkInfo.old_seller_price * 10) / 10}*
                                                </p>
                                                        :
                                                        <p className="art-details"> Not For Sale
                                                </p>
                                                }
                                                {(this.state.technique) ?

                                                    <p className="art-details">


                                                        Technique : {this.state.technique}


                                                    </p>

                                                    :

                                                    <p className="art-details">
                                                        <p className="art-details">

                                                            Medium :
                                                            {` ` + figuredOutMedium


                                                            }{
                                                                // figuredOutCustomMedium
                                                                !!this.state.custom_medium ? !!figuredOutMedium ? `, ${this.state.custom_medium}` : this.state.custom_medium : ""
                                                            }
                                                            <p className="art-details mt-2">

                                                                Base  : {` ` + figuredOutBase
                                                                }{
                                                                    // figuredOutCustomBase
                                                                    !!this.state.custom_base ? !!figuredOutBase ? `, ${this.state.custom_base}` : this.state.custom_base : ""
                                                                }
                                                            </p>
                                                        </p>
                                                    </p>
                                                }
                                                {
                                                    // localStorage.hasOwnProperty("preferred_dimension") ?
                                                    // <p className="art-details">
                                                    //     Dimension :  {(this.state.artworkInfo.base_height || 0)}{(localStorage.hasOwnProperty("preferred_dimension"))} x {(this.state.artworkInfo.base_width || 0)}{(localStorage.getItem("preferred_dimension"))} x {(this.state.artworkInfo.base_depth || 0)}{(localStorage.getItem("preferred_dimension"))}


                                                    // </p>
                                                    // :
                                                    (this.state.artworkInfo.dimension) ?
                                                        <p className="art-details">
                                                            Dimension :
                                                            {` ` + Math.round(this.state.artworkInfo.width * 10) / 10 || 0}
                                                            {` x `}{Math.round(this.state.artworkInfo.height * 10) / 10 || 0}{` x `}
                                                            {Math.round(this.state.artworkInfo.depth * 10) / 10 || 0}{` `}
                                                            {(this.state.artworkInfo.dimension.toUpperCase())}


                                                        </p> :
                                                        <p className="art-details">

                                                            Dimension    :  {this.state.artworkInfo.old_dimension}
                                                        </p>

                                                }

                                                <p className="art-details">
                                                    Year :{(this.state.artworkInfo.year) ? ` ${this.state.artworkInfo.year}` : ` ${this.state.artworkInfo.old_year}`}
                                                </p>
                                                <p style={{ "margin-top": -10, display: (this.state.artworkInfo.wish_to_sell) ? "" : "none" }}>
                                                    <span style={{ "font-size": 9, "margin-top": 0 }}><super>*</super> Shipping and handling charges extra</span>
                                                </p>
                                            </div>
                                        </div>


                                    </div>


                                    <h3 className="main-label">Personal Details</h3>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="email">YOUR EMAIL </label>
                                                <input onChange={this.handleInputTextChange.bind(this)} value={this.state.formInputs.email} className="input-text" type="email" name="email" id="email"
                                                    placeholder="Enter email for communication"
                                                    required />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label htmlFor="country-code">Mobile</label>
                                        <div className="form-group">
                                            <div className="inline-form-phone">

                                                <input value={this.state.formInputs.country_code} onChange={this.handleInputTextChange.bind(this)} type="text" className="form-control" id="country-code"
                                                    name="country_code" placeholder="+1"
                                                    required="" maxLength="3" />
                                                <input type="number" value={this.state.formInputs.contact_no} onChange={this.handleInputTextChange.bind(this)} className="form-control" name="contact_no" id="contact"
                                                    title="Please Enter Valid Mobile Number" placeholder="Phone number (optional)"
                                                    required="" maxLength="10" />
                                                {/* value={this.state.phone} */}

                                            </div>
                                        </div>
                                    </div>





                                    <div className="row ml-15 mt-15">

                                        <div className="col-md-6 pl-0 pr-10">
                                            <div className="form-group">
                                                <p>
                                                    <label htmlFor="city">City </label>

                                                    <input className="input-text" type="text" name="city" id="city"
                                                        placeholder="City"
                                                        onChange={this.handleInputTextChange.bind(this)}
                                                        value={this.state.formInputs.city}
                                                        required />
                                                </p>
                                            </div>
                                        </div>

                                        <div className="col-md-6 pl-0 pr-10">
                                            <div className="form-group">
                                                <p>
                                                    <label htmlFor="country">Country </label>


                                                    <CountryDropdown className="form-element-small-input" style={{ padding: "0%" }}

                                                        value={this.state.formInputs.country}
                                                        onChange={(val) => this.selectCountry(val)}
                                                    />
                                                </p>
                                            </div>
                                        </div>




                                    </div>


                                    <h3 className="main-label"> OTHER DETAILS </h3>

                                    <div className="row ml-15 mt-15">
                                        {/* <div className="col-md-6 pl-0 pr-0"> */}
                                        {/* <div className="form-group"> */}

                                        <div className="col-md-12 pl-0 pr-10">
                                            <div className="form-group">
                                                <p>
                                                    <label htmlFor="email">PAYMENT CURRENCY </label>
                                                    <select className="form-element-small-input" placeholder="Select Currency" onChange={this.handleCurrencySelection.bind(this)} value={this.state.formInputs.currency_code}  >
                                                        <option style={{ display: "none" }}> Select Currency</option>
                                                        {
                                                            this.props.generalStore.Currencies.map((el, idx) =>
                                                                <option value={el.key}>{el.display}</option>
                                                            )
                                                        }
                                                    </select>
                                                </p>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                        {/* </div> */}
                                        {/* <div className="col-md-6 pr-10 mode-payment">
                                        <div className="form-group">
                                            <p>
                                                <p>
                                                    <label htmlFor="currency">Mode Of Payment </label>

                                                    <input className="input-text" type="text" name="currency"
                                                           id="currency"
                                                           value=""
                                                           required/>
                                                </p>
                                            </p>
                                        </div>
                                    </div> */}
                                    </div>

                                    <div className="col-md-12 mt-15">
                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="address1">MESSAGE</label>
                                                <textarea value={this.state.formInputs.message} onChange={this.handleInputTextChange.bind(this)}
                                                    name="message"
                                                    placeholder="Other message(optional)"
                                                    required className="form-element-large-input">
                                                </textarea>
                                            </p>
                                        </div>
                                    </div>


                                    <p className="ml-15 mt-15 mb-25">
                                        <input type="submit" name="submit"
                                            onClick={this.sendBuyRequest.bind(this)}
                                            className="masterpieces-primary-buttons btn-primary"
                                            value="PLACE BUY REQUEST" />
                                    </p>


                                </div>
                            </div>

                        </div>
                    </article>
                </div >

            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/requests_forms/place-buy-request.js